import { formatDate, parseDate } from 'utils/format';
import { TEMPLATE_LAYOUT } from './constants';
import { getLayoutType } from './page';
import {
  getMinimumNumberOfPages,
  getMaximumNumberOfPages,
  getMaximumNumberOfPhotos,
} from './counts';
import { isChangeOrientationEnabled } from './orientation';

export function getInitialPageId(template, pages = []) {
  if (template.cover) {
    if (pages.length > 0) {
      return pages[0].id;
    }

    return template.cover[0].id;
  }

  if (pages.length === 1) {
    return pages[0].id;
  }

  if (getLayoutType(template) === TEMPLATE_LAYOUT.PAGE) {
    return template.pages[0].id;
  }

  if (getLayoutType(template) === TEMPLATE_LAYOUT.SEQUENCE) {
    const pageId = formatDate(new Date(), 'YYYY-MM');
    if (template.pages.find((page) => page.id === pageId)) {
      return pageId;
    }
  }

  return '';
}

export function getInitialCoverId(template, pages = []) {
  if (pages.length > 0) {
    return pages[0].id;
  }

  return template.cover[0].id;
}

export function isChangePageEnabled(template, pages = []) {
  return (
    getLayoutType(template) === TEMPLATE_LAYOUT.AUTOMATIC &&
    template.template.maximumNumberOfPages === 1 &&
    template.pages.length > 1 &&
    !isChangeOrientationEnabled(template, pages[0])
  );
}

export function isSelectInitialPageEnabled(template, renderCallback) {
  if (getLayoutType(template) === TEMPLATE_LAYOUT.SEQUENCE) {
    const actualMonth = formatDate(new Date(), 'YYYY-MM');

    let initialPages = [];
    template.pages.forEach((page) => {
      if (page.id >= actualMonth) {
        initialPages.push({
          ...page,
          label: formatDate(parseDate(page.id, 'YYYY-MM'), 'MMMM YYYY'),
        });
      }
    });

    const minimumNumberOfPages = getMinimumNumberOfPages(template);
    initialPages = initialPages.slice(0, initialPages.length + 1 - minimumNumberOfPages);

    if (initialPages.length > 1) {
      return renderCallback(initialPages);
    }
  }

  return null;
}

export function isRemovePageEnabled(template, pages = []) {
  return (
    getLayoutType(template) === TEMPLATE_LAYOUT.AUTOMATIC &&
    pages.length > getMinimumNumberOfPages(template)
    // && pages.length <= getMaximumNumberOfPages(template)
  );
}

export function isDuplicatePageEnabled(template, pages = []) {
  return (
    getLayoutType(template) === TEMPLATE_LAYOUT.AUTOMATIC &&
    pages.length < getMaximumNumberOfPages(template)
  );
}

export function isDuplicatePhotoEnabled(template, photos = []) {
  return photos.length < getMaximumNumberOfPhotos(template);
}
